import {Component, OnInit} from '@angular/core';
import {App} from '@capacitor/app';
import {Platform} from '@ionic/angular';
import packageInfo from '../../../../../package.json';

@Component({
  selector: 'info',
  template: `
    {{name}} ({{version}})
  `
})
export class InfoComponent implements OnInit {
  public version: string;
  public name: string;

  constructor(private readonly platform: Platform) {

  }

  ngOnInit(): void {
    if (this.platform.is('capacitor')) {
      App.getInfo().then(info => {
        this.version = `${info.version}-${info.build}`;
        this.name = info.name;
      });
    } else {
      this.version = packageInfo.version;
      this.name = packageInfo.name;
    }
  }
}
